import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const CardStat = ({ title, value, subValue }) => (
    <div className="col-6 md:col-3">
        <div className="card shadow-none border-1 py-2 px-3 md:px-4 bg-white" 
             style={{ borderRadius: '8px', minHeight: '115px', borderColor: '#e5e5e5' }}>
            <div style={{ color: '#9a9a98', fontSize: '0.75rem' }}>
                {title}
            </div>
            <div style={{ fontSize: '24px', color: '#1a1a1a' }}>
                {value}
            </div>
            {subValue && (
                <div style={{ color: '#0f6e56', fontSize: '0.7rem', fontWeight: '500' }}>
                    {subValue} vs mois dernier
                </div>
            )}
        </div>
    </div>
);

const HeaderDem = ({ 
    rejectedDevisList = [], 
    displayRejectedPopup = false, 
    dismissedRejected = false, 
    setDisplayRejectedPopup 
}) => {
    const [stats, setStats] = useState({ 
        nouvelles: 0, 
        en_suivi: 0, 
        valides: 0, 
        realises_mois: 0, 
        progression: "" 
    });

    // Fonction pour ouvrir le popup
    const handleOpenRejectedPopup = () => {
        if (setDisplayRejectedPopup) {
            setDisplayRejectedPopup(true);
        }
    };

    return (
      <div className="p-2">
        <div
          className="flex flex-column md:flex-row justify-content-between md:align-items-end mb-4"
          style={{ paddingBottom: "10px" }}
        >
          <div className="mb-3 md:mb-0">
            <a
              href="/historiqueMailDem"
              style={{
                fontSize: "0.65rem",
                textTransform: "uppercase",
                letterSpacing: "1.2px",
                color: "#9a9a98",
                fontWeight: "500",
                marginBottom: "6px",
              }}
            >
              Historique des mails dem
            </a>
            
            {/* Affichage des devis rejetés */}
            {rejectedDevisList.length > 0 &&
              !displayRejectedPopup &&
              !dismissedRejected && (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                  onClick={handleOpenRejectedPopup}
                >
                  <span
                    style={{
                      background: "#dc2626",
                      color: "white",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    {rejectedDevisList.length}
                  </span>
                  {/* <span
                    style={{
                      marginLeft: "4px",
                      fontSize: "12px",
                      color: "#dc2626",
                    }}
                  >
                    Devis rejetés
                  </span> */}
                </div>
              )}
          </div>

          <Button
            label="Nouvelle fiche Dem"
            icon="pi pi-plus"
            onClick={() => window.open("https://tally.so/r/mDVg6q", "_blank")}
            className="w-full md:w-auto"
            style={{
              backgroundColor: "#0971b7",
              border: "none",
              color: "#ffffff",
              fontSize: "0.8rem",
              fontWeight: "700",
              borderRadius: "8px",
              padding: "10px 18px",
            }}
          />
        </div>
      </div>
    );
};

export default HeaderDem;